import { BaseProps, Icon, Tooltip } from '@bitrise/bitkit';
import { TypeCrashStatus } from '@trace/types';
import React, { FunctionComponent } from 'react';
import {
  CRASH_STATUS_COLOR_MAP,
  CRASH_STATUS_NAME_MAP,
  CRASH_STATUS_ICON_MAP,
} from '../../../constants/Crashes';

interface Props extends BaseProps {
  status: TypeCrashStatus;
}

const CrashStatusIcon: FunctionComponent<Props> = (props) => {
  const { status, ...rest } = props;

  return (
    <Tooltip title={CRASH_STATUS_NAME_MAP[status]}>
      {({ ref, ...restTooltip }) => (
        <Icon
          {...rest}
          {...restTooltip}
          innerRef={ref}
          name={CRASH_STATUS_ICON_MAP[status]}
          textColor={CRASH_STATUS_COLOR_MAP[status]}
        />
      )}
    </Tooltip>
  );
};

export default CrashStatusIcon;
